import { LayoutEdit } from 'features/layouts/LayoutEdit';
import { ROLE_TYPE } from 'hooks/roles/types';
import useRequireRoles from 'hooks/roles/useRequireRoles';

function SiteConfigLayoutEdit() {
  useRequireRoles(ROLE_TYPE.ADMIN, ROLE_TYPE.SUPER);
  return <LayoutEdit />;
}

export default SiteConfigLayoutEdit;
